import { PUBMED_RIS } from "@/graphql/pubmed.graphql";
import { useLazyQuery } from "@apollo/react-hooks";

const usePaperExport = (doi: string) => {
  const [loadExport, { called, loading, data }] = useLazyQuery(PUBMED_RIS, {
    variables: { doi },
  });
  return {
    loadExport,
    loading,
    data,
    called,
  };
};

export default usePaperExport;
